import React from 'react'

export default function ColorCode ({
  imageUrl,
  borderHex,
  backgroundColor,
  text
}) {
  if (!text) {
    return null
  }

  return (
    <div className='car-color-code'>
      {
        imageUrl
          ? <img
              className='car-color-code__code'
              src={imageUrl}
              style={{
                borderColor: borderHex
              }}
            />
          : <span
              className='car-color-code__code'
              style={{
                backgroundColor: backgroundColor || '#FFFFFF',
                borderColor: borderHex
              }}
            />
      }
      {text}
    </div>
  )
}
